/**
 * @file file.ts
 * @description Сервис для работы с файлами в Task Manager. Обеспечивает загрузку, получение и управление файловыми вложениями к задачам, включая обработку различных типов файлов и их метаданных.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['axios', '../actions.js', '@src/types']
 * @related-files ['C:\laragon\www\task-manager\src\api\actions.js', 'C:\laragon\www\task-manager\src\types\index.ts']
 */

import axios, { AxiosError, AxiosResponse } from 'axios';
import { postRequest, getFile } from '../actions.js';
import { TAttachment } from '@src/types';

export const FileService = {
    /**
     * Получает файл по указанной ссылке
     * @param {string} link - Ссылка или идентификатор файла для получения
     * @returns {Promise} Промис с данными файла
     */
    get: async (link: string): Promise<AxiosResponse | AxiosError> => {
        return await getFile(`file/${link}`);
    },
    
    /**
     * Создает новый файл-вложение путем загрузки
     * @param {FormData} file - Данные файла в формате FormData для загрузки
     * @returns {Promise<TAttachment | undefined>} Промис с объектом вложения или undefined при ошибке
     */
    create: async (file: FormData): Promise<TAttachment | undefined> => {
        const response = await postRequest('file', file, undefined);

        if (axios.isAxiosError(response)) {
            return undefined;
        }

        return response.data as TAttachment;
    }
};
